<template>
	<div v-if="$screen.width <= 992" class="animated fadeIn pr-1 pl-1">
		<div class="container-mobile">
			<div class="my-expense-mobile">
				<div v-if="invoiceItems.length > 0 && !forPending && !forApproved" class="my-expense-status-actions p-1">
					<div class="check-actions cursor-pointer" @click="switchCheckAll">
						<div class="d-flex text-left" v-if="checkAll">
							{{ FormMSG(46, 'None') }}&nbsp;
							<component :is="getLucideIcon('Square')" :size="16" />
						</div>
						<div class="d-flex" v-else>
							{{ FormMSG(45, 'All') }}&nbsp;
							<component :is="getLucideIcon('CheckSquare')" :size="16" />
						</div>
					</div>
				</div>
				<div class="content pb-3" v-if="invoiceItems.length > 0">
					<div
						class="card-expense"
						v-for="(invoice, invoiceIndex) in invoiceItems"
						:key="invoice.id"
						:id="`${notSubmittedState && parseInt(invoice.validated, 10) === 0 ? 'card-expense-' + invoice.id : ''}`"
					>
						<div class="wrapper">
							<div class="resume">
								<div class="first-col" v-if="!forPending && !forApproved">
									<b-form-checkbox
										v-if="+invoice.amountTotal !== 0"
										size="lg"
										v-model="notSubmittedInvoices"
										:value="invoice"
										@change="setSelectedItem($event, invoice, 'card-expense-' + invoice.id)"
									/>
								</div>
								<div class="second-col" :style="`width: ${notSubmittedState && parseInt(invoice.validated, 10) === 0 ? '56.5%;' : '67.5%;'}`">
									<div class="description">
										{{ invoice.description }}
									</div>
									<div class="title">#{{ invoice.id }}</div>
									<div class="amount">{{ rendCurrency(invoice.amountTotal) }}</div>
									<div class="date">
										{{ dateToLiteral(invoice.date) }}
									</div>
								</div>
								<div class="third-col">
									<div class="status-wrapper flex flex-col justify-content-between">
										<div class="wrap-status d-flex">
											<div v-if="invoice.allExpenseItemIsInContract === false" class="d-flex justify-content-start align-items-center">
												<button
													class="btn-transparent text-color-rhapsody-in-blue"
													v-b-tooltip.left.html
													:title="tooltipInvoiceOutsideContract()"
												>
													<component :is="getLucideIcon('AlertTriangle')" color="#EA4E" :size="18" />
												</button>
											</div>
											<div :class="`status ${invoice.statusClass}`">
												{{ invoice.validatedStatus }}
											</div>
										</div>
										<div class="type">
											<span class="icon">
												<!-- #526878D6 -->
												<component :is="getLucideIcon('Ticket')" color="#5B6164D6" :size="16" v-if="invoice.type === 0" />
												<!-- ticket -->
												<component :is="getLucideIcon('FileText')" color="#5B6164D6" :size="14" v-if="invoice.type === 1" />
												<!-- invoice -->
												<component :is="getLucideIcon('Car')" color="#5B6164D6" :size="16" v-if="invoice.type === 2" />
												<!-- mileage -->
											</span>
											<span class="label" :style="`${invoice.type === 2 ? 'margin-top: 2px;' : ''}`">{{ invoice.typeString }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="footer">
							<div class="actions">
								<div class="first-col" v-if="notSubmittedState && invoice.images" @click="showPicture(invoice.images, invoice)">
									<div class="icon">
										<component :is="getLucideIcon('FileImage')" color="#06263E" :size="16" />
									</div>
									<div class="label" style="margin-top: 1px">{{ FormMSG(28, 'See Receipt') }}</div>
								</div>
								<div class="second-col" :style="`width: '100%`">
									<div class="cursor-pointer d-flex flex-row" v-if="notSubmittedState" @click="viewInvoiceDetail(invoice, invoiceIndex)">
										<div class="icon">
											<component :is="getLucideIcon('Edit')" color="#06263E" :size="16" />
										</div>
										<div class="label">{{ FormMSG(29, 'Edit') }}</div>
									</div>
									<div class="cursor-pointer d-flex flex-row" v-if="submittedState" @click="viewInvoiceDetail(invoice, invoiceIndex)">
										<div class="icon">
											<component :is="getLucideIcon('Eye')" color="#06263E" :size="16" />
										</div>
										<div class="label">{{ FormMSG(33, 'View') }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="empty-data pb-3">
					{{ FormMSG(18, 'No invoice found') }}
				</div>
				<b-row class="footer-fixed" v-if="notSubmittedInvoices.length > 0 && !forMultipleInvoice">
					<b-col cols="12">
						<div v-if="forApprove">
							<b-button block size="lg" variant="primary" class="mb-2" @click="handleApproveInvoice">
								<span>{{ FormMSG(38, 'Approve') }} {{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}</span>
							</b-button>
							<b-button block size="lg" variant="outline-primary" class="mb-2" @click="handleRejectInvoice">
								<span>{{ FormMSG(37, 'Reject') }} {{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}</span>
							</b-button>
						</div>
						<div v-if="forDraft">
							<b-button
								:disabled="selectedInvoiceMobileHasRefusedItem"
								block
								size="lg"
								variant="primary"
								class="mb-2"
								@click="handleSendInvoiceForApproval"
							>
								<span
									>{{ FormMSG(39, 'Send for Approval') }}
									{{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}</span
								>
							</b-button>
							<b-button block size="lg" variant="outline-primary" class="mb-2" @click="handleDeleteInvoice">
								<span>{{ FormMSG(35, 'Delete') }} {{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}</span>
							</b-button>
						</div>
					</b-col>
				</b-row>
				<b-row v-if="notSubmittedInvoices.length > 0 && forMultipleInvoice">
					<b-col cols="12">
						<b-button block size="lg" variant="outline-primary" class="mb-2" @click="handleDeleteInvoice">
							<span>{{ FormMSG(35, 'Delete') }} {{ notSubmittedInvoices.length > 0 ? `(${notSubmittedInvoices.length})` : '' }}</span>
						</b-button>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>
<script>
import globalMixin from '@/mixins/global.mixin';
import invoiceToolsMixin from '@/mixins/invoicesTools.mixin';
import languageMessages from '@/mixins/languageMessages';
import mapProps from '@/shared/vuePropsMapper';
import moment from 'moment';
import { rendCurrency } from '~helpers';
import _ from 'lodash';

export default {
	name: 'InvoiceItemMobile',
	mixins: [languageMessages, globalMixin, invoiceToolsMixin],
	props: {
		invoiceItems: Array,
		notSubmittedState: Boolean,
		submittedState: Boolean,
		...mapProps(['forApprove', 'forDraft', 'forPending', 'forApproved', 'forMultipleInvoice'], {
			type: Boolean,
			default: false
		})
	},
	data() {
		return {
			notSubmittedInvoices: [],
			checkAll: false,
			rendCurrency
		};
	},
	methods: {
		switchCheckAll() {
			this.checkAll = !this.checkAll;
			if (this.checkAll) {
				this.notSubmittedInvoices = _.cloneDeep(this.invoiceItems);
			} else {
				this.notSubmittedInvoices = [];
			}
			this.$emit('setSelectedItem', this.notSubmittedInvoices);
		},
		setSelectedItem(event) {
			if (event.length === this.invoiceItems.length) {
				this.checkAll = true;
			} else {
				this.checkAll = false;
			}
			this.$emit('setSelectedItem', event);
		},
		handleApproveInvoice() {
			this.$emit('approveInvoice', this.notSubmittedInvoices);
			this.notSubmittedInvoices = [];
		},
		handleRejectInvoice() {
			this.$emit('rejectInvoice', this.notSubmittedInvoices);
			this.notSubmittedInvoices = [];
		},
		handleSendInvoiceForApproval() {
			this.$emit('sendInvoiceForApproval', this.notSubmittedInvoices);
			this.notSubmittedInvoices = [];
		},
		handleDeleteInvoice() {
			this.$emit('deleteInvoice', this.notSubmittedInvoices);
			this.notSubmittedInvoices = [];
		},
		dateToLiteral(invoiceDate) {
			const langCurrent = this.currentLang;
			const fullLiteralDate = moment(invoiceDate).locale(`${langCurrent}`).format(`dddd, Do MMMM YYYY`);

			return fullLiteralDate;
		},
		viewInvoiceDetail(invoice, invoiceIndex) {
			this.$emit('viewInvoiceDetail', invoice, invoiceIndex);
		}
	},
	computed: {
		check() {
			return this.$store.getters.distanceUnit;
		},
		selectedInvoiceMobileHasRefusedItem() {
			return this.notSubmittedInvoices.length > 0 && this.notSubmittedInvoices.some((item) => this.isInvoiceRefused(item));
		}
	}
};
</script>
